export const res_detail = {
  methods: {
    get_detail_data: function(module, ids){
      this.fetch_status = "getting";
      return new Promise((resolve, reject) => {
        this.$http.get(this.$store.getters.api_endpoint + "/" + module + ids.join("/"))
          .then( response => {
            this.fetch_status = "done";
            if(response && "data" in response){
              if(this.$store.getters.debug){
                console.log("response.data:" + JSON.stringify(response.data));
              }
              this.original_data = Object.assign({}, response.data);
              this.data = response.data;
              return resolve(true);
            }
          })
          .catch( error => {
            this.fetch_status = "error";
            if(this.http_error(error)){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
            return resolve(false);
          });
      });
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    confirm_delete_data: function(module, ids){
      if(!this.$refs.delete_confirm){
        return;
      }
      this.$refs.delete_confirm.open()
        .then( result => {
          if(result){
            this.delete_data(module, ids);
          }
        });
    },
    delete_data: function(module, ids){
      var url = this.$store.getters.api_endpoint + "/" + module + "/" + ids.join("/");
      this.$http.delete(url)
        .then( response => {
          this.$store.commit("setNotification", {
            type: "success",
            message: {
              eid: "E1" + this.module_id + "002" + ":00000000",
              param: {}
            }
          });
          this.$router.push(this.get_prev(module));
        })
        .catch(error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    deletable: function(){
      if(this.$store.getters.debug){
        console.log(this.mode);
      }
      if(this.mode === "user"){
        return this.$store.getters.user.uid === this.data.uid;
      }else if(this.mode === "group"){
        return this.$store.getters.user.gid === this.data.gid;
      }else{  // organization
        return true;
      }
    },
    get_prev: function(module){
      var prev = "/" + module;
      if(this.$route.query.referer){
        var referers = this.$route.query.referer.split(":");
        prev = referers.pop();
        if(referers.length > 0){
          prev += "?referer=" + encodeURIComponent(referers.join(":"));
        }
      }
      return prev;
    },
    change_data: function(module, ids){
      if(this.data && this.editable){
        var parameters = {};
        for(var key in this.editable){
          if(this.data[key] !== this.original_data[key]){
            parameters[key] = this.data[key];
          }
        }
        var url = this.$store.getters.api_endpoint + "/" + this.get_prefix() + module + "/" + ids.join("/");
        var take_over = {
          parent: this,
          parameters: parameters
        }
        this.$http.put(url,
                       parameters,
                       {
                         headers: {
                           'Content-Type': 'application/json'
                         }
                       })
          .then(function(response){
            this.parent.$store.commit("setNotification", {
              type: "success",
              message: {
                eid: "E1" + this.parent.module_id + "003" + ":00000000",
                param: {}
              }
            });
            var original_data = Object.assign({}, this.parent.original_data);
            for(var key in this.parameters){
              original_data[key] = this.parent.data[key];
            }
            this.parent.original_data = original_data;
          }.bind(take_over))
          .catch( error => {
            if(this.http_error(error)){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          });
      }
    },
    changeable: function(){
      if(this.$store.getters.debug){
        console.log(this.mode);
      }
      if(this.mode === "user"){
        if(this.$store.getters.debug){
          console.log(this.$store.getters.user.uid);
          console.log(this.data.uid);
        }
        return this.$store.getters.user.uid === this.data.uid;
      }else if(this.mode === "group"){
        return this.$store.getters.user.gid === this.data.gid;
      }else{  // organization
        return true;
      }
    },
    compare_array: function(a, b){
      if((!Array.isArray(a) && !Array.isArray(b))
        || (Array.isArray(a) && !Array.isArray(b) && a.length === 0)
        || (!Array.isArray(a) && Array.isArray(b) && b.length === 0)){
        return true;
      }else if(!Array.isArray(a) || !Array.isArray(b)){
        return false;
      }else if(a.length !== b.length){
        return false;
      }
      for(var item of a){
        if(b.indexOf(item) === -1){
          return false;
        }
      }
      for(var item of b){
        if(a.indexOf(item) === -1){
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    modifiable: function(){
      var result = false;
      if(this.data && this.editable){
        for(var key in this.editable){
          var diff = (this.data[key] !== this.original_data[key]);
          if(Array.isArray(this.data[key]) || Array.isArray(this.original_data[key])){
            diff = !this.compare_array(this.data[key], this.original_data[key]);
          }
          if(diff){
            if(this.editable[key]()){
              // 差分あり かつ 入力が正しいものが1つでもあればtrue
              result = true;
            }else{
              // 差分があるが、入力が正しくなければ一発でfalse
              return false;
            }
          }
        }
      }
      return result;
    }
  }
}
